var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.question.options),function(option,index){return _c('v-checkbox',{key:index,attrs:{"rules":_vm.rules,"label":option,"value":option,"readonly":_vm.readonly,"disabled":_vm.readonly},on:{"change":_vm.handleInput},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }